import CircleIcon from '@mui/icons-material/Circle';
import { Card, Stack } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { FC, useEffect, useState } from 'react';
import Heading from 'src/components/atoms/Heading/Heading';

export interface ToggleButtonInput {
    callbackFunction: (productId: number) => void;
    name: string;
    id: number;
    hasChanges?: boolean;
}

interface Props {
    buttonInputs: ToggleButtonInput[];
    header: string;
    defaultValue?: string | null;
}

export const ExclusiveToggleButtonGroup: FC<Props> = ({ buttonInputs, header, defaultValue }) => {
    const value = defaultValue ?? buttonInputs[0].name;
    const [active, setActive] = useState<string>();

    useEffect(() => setActive(value), [value]);

    const handleSelect = (_: unknown, v: string) => !!v && setActive(v);

    return (
        <Card sx={{ p: 4, flex: 1 }}>
            <Stack
                sx={{
                    gap: 2,
                }}
            >
                <Heading>{header}</Heading>
                <ToggleButtonGroup value={active} exclusive onChange={handleSelect} aria-label="text alignment">
                    {buttonInputs.map((toggleButton, index) => {
                        return (
                            <ToggleButton
                                value={toggleButton.name}
                                key={index}
                                aria-label={toggleButton.name + ' selector'}
                                onClick={() => toggleButton.callbackFunction(toggleButton.id)}
                            >
                                <Stack
                                    direction="row"
                                    sx={{
                                        gap: 2,
                                        alignItems: 'center',
                                    }}
                                >
                                    {toggleButton.hasChanges && <CircleIcon sx={{ fontSize: '8px' }} color="info" />}
                                    {toggleButton.name}
                                </Stack>
                            </ToggleButton>
                        );
                    })}
                </ToggleButtonGroup>
            </Stack>
        </Card>
    );
};
